// {{BASE_URL}}/api/schemeType
import * as Types from '../types';
import { Environment } from '../../../config';
import request from '../../../utils/request';

interface IDataItems {
  applicant_username: string;
  vat_return_id: number;
  vat_return_version_id: number;
  quarter_id: number;
  ending_month: number;
  short_text: string;
  starting_month: number;
  year: number;
  period_start_date: Date;
  period_end_date: Date;
  vat_return_reference: string;
  vat_return_status_id: number;
  vat_return_status_description: string;
  is_sent: number;
  vat_return_state: string;
  submission_date: Date;
  vat_return_due_date: Date;
  vat_id_num: string;
  is_nill: number;
  is_updated: number;
  can_be_updated: number;
  version: Date;
  modified_by: string;
  modified_at: Date;
  vat_amount: number;
  paid_amount: number;
  allocated_amount: number;
  reimbursed_amount: number;
}

interface IPaging {
  page: string;
  pageSize: string;
  total: number;
}

interface IVatReturnListOutput {
  items: IDataItems[];
  paging: IPaging;
}

interface IVatReturnListInput {
  sortField: string;
  page: number;
  pageSize: number;
  order: 'asc' | 'desc';
  vat_num?: string;
  period?: string;
  year?: string;
  declaration_status?: string;
  vat_return_state?: string;
}

export const fetchVatReturnList = async (
  payload: IVatReturnListInput
): Promise<Types.ResponseOutput> => {
  let searchQuery = '';
  if (payload.vat_num) searchQuery += `&vat_num=${payload.vat_num}`;
  if (payload.period) searchQuery += `&period=${payload.period}`;
  if (payload.year) searchQuery += `&year=${payload.year}`;
  if (payload.declaration_status)
    searchQuery += `&declaration_status=${payload.declaration_status}`;
  if (payload.vat_return_state)
    searchQuery += `&vat_return_state=${payload.vat_return_state}`;

  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/vatreturn/list?page=${payload.page}&pageSize=${payload.pageSize}&sortField=${payload.sortField}&order=${payload.order}${searchQuery}`
  );

  let _data: IVatReturnListOutput = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

interface IListAll {
  vat_return_id: number;
  vat_return_reference: string;
}

interface IVatReturnListAllOutput {
  items: IListAll[];
  paging: IPaging;
}
export const fetchVatReturnListAll =
  async (): Promise<Types.ResponseOutput> => {
    const { data }: any = await request(
      'get',
      `${Environment.API_BASE_URL}/api/vatreturn/listAll`
    );
    let _data: IVatReturnListAllOutput = data.data;
    let output: Types.ResponseOutput = {
      message: data.message,
      data: _data,
      status: data.status,
    };
    return output;
  };

interface IQuarter {
  quarter_id: number;
  starting_month: number;
  ending_month: number;
  short_text: string;
}

export const fetchQuarters = async (): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/vatreturn/quarters`
  );

  let _data: Array<IQuarter> = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

export const fetchMonthQuarters = async (): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/vatreturn/month-quarters`
  );

  let _data: Array<IQuarter> = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

export interface IAddVatReturn {
  user_id?: number;
  quarter: number;
  year: number;
  start_date?: Date | null;
  end_date?: Date | null;
}

export const addVatReturn = async (
  payload: IAddVatReturn
): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'post',
    `${Environment.API_BASE_URL}/api/vatreturn`,
    payload
  );

  let _data: Array<IQuarter> = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

interface ICorrectionsCountry {
  country_id: number;
  country: string;
  due_balance: number;
}
export const fetchCorrectionsCountries = async (
  vat_return_id: number,
  year: number,
  quarter_id: number
): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/country/corrections?vat_return=${vat_return_id}&year=${year}&quarter_id=${quarter_id}`
  );
  let _data: Array<ICorrectionsCountry> = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

interface IAddVatReturnPayment {
  amount: number;
  payment_date: Date;
  vat_return_id: string;
}
export const addVatReturnPayment = async (
  payload: IAddVatReturnPayment
): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'post',
    `${Environment.API_BASE_URL}/api/vatreturn/${payload.vat_return_id}/payment`,
    {
      amount: payload.amount,
      payment_date: payload.payment_date,
    }
  );
  let output: Types.ResponseOutput = {
    message: data.message,
    data: data.data,
    status: data.status,
  };
  return output;
};

export interface ITradersInfo {
  applicant_id: number;
  user_id: number;
  vat_id_num: string;
}
export const fetchAgentTraders = async (): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/applicant/agent-traders`
  );
  let _data: Array<ITradersInfo> = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};
